import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props)  {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="iso-8859-1"?>

<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M256,0c-48.551,0-95.818,13.675-136.693,39.545l16.044,25.35C171.419,42.066,213.139,30,256,30
			c42.861,0,84.581,12.066,120.648,34.895l16.044-25.35C351.818,13.675,304.551,0,256,0z"/>
	</g>
</g>
<g>
	<g>
		<path d="M376.649,447.105C340.581,469.934,298.861,482,256,482c-42.861,0-84.581-12.066-120.648-34.895l-16.044,25.35
			C160.182,498.325,207.449,512,256,512c48.551,0,95.818-13.675,136.693-39.545L376.649,447.105z"/>
	</g>
</g>
<g>
	<g>
		<path d="M472.455,119.307l-25.35,16.044C469.934,171.419,482,213.139,482,256c0,42.861-12.066,84.581-34.895,120.648l25.35,16.044
			C498.325,351.818,512,304.551,512,256C512,207.449,498.325,160.182,472.455,119.307z"/>
	</g>
</g>
<g>
	<g>
		<path d="M64.895,135.352l-25.35-16.045C13.675,160.182,0,207.449,0,256c0,48.551,13.675,95.818,39.545,136.693l25.35-16.044
			C42.066,340.581,30,298.861,30,256C30,213.139,42.066,171.419,64.895,135.352z"/>
	</g>
</g>
<g>
	<g>
		<path d="M256,204c-28.673,0-52,23.327-52,52c0,28.673,23.327,52,52,52c28.673,0,52-23.327,52-52C308,227.327,284.673,204,256,204z
			 M256,278c-12.131,0-22-9.869-22-22s9.869-22,22-22c12.131,0,22,9.869,22,22S268.131,278,256,278z"/>
	</g>
</g>
</svg>
`,
      }}
    />
  );
};
